export default __webpack_public_path__ + "static/images/artigianalita-top-1440-a4612595f0f323548a6db76a055f738f.jpg";